/**
 * Typed envelope for events emitted on the `agent_com_<agentId>` channel.
 *
 * The wire shape `{ event: string, content: object }` is produced by the
 * agentbuilder backend (see `art-agentbuilder-v2/src/builder/response_types.py`
 * `RESPONSE_TYPE_TO_EVENT`). The `event` string is the discriminator; each
 * variant's `content` shape mirrors the corresponding Pydantic class.
 */
export const AGENT_EVENTS = [
    "agent_output",
    "agent_error",
    "human_input_request",
    "agent_wait",
    "planner_correction",
];
const KNOWN_EVENT_SET = new Set(AGENT_EVENTS);
/**
 * Runtime guard: narrows an unknown envelope to the typed `AgentEvent`
 * union when the event name matches a known kind. Use to drive an
 * exhaustive `switch` on `evt.event`.
 */
export function isKnownAgentEvent(e) {
    return KNOWN_EVENT_SET.has(e.event);
}
